import { InjectionToken } from '@angular/core';
import { CookieConsentGamblingAdult, CookieConsentOption } from '@bcf-vanilla-ts-v1-configurators/tokens/cookies/types';
import { CookieConsentGamblingAdultLoader } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const COOKIE_CONSENT_DISABLED_ADDITONAL_URLS: InjectionToken<string[]> = new InjectionToken<string[]>(
  'cookieConsentDisabledAdditionalUrls'
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const COOKIE_CONSENT_GAMBLING_ADULT_LOADER: InjectionToken<
  CookieConsentGamblingAdultLoader<CookieConsentGamblingAdult | undefined>
> = new InjectionToken<CookieConsentGamblingAdultLoader<CookieConsentGamblingAdult | undefined>>(
  'cookieConsentGamblingAdultLoader',
  {
    factory: () => () => Promise.resolve(undefined)
  }
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const COOKIE_CONSENT_OPTIONS: InjectionToken<CookieConsentOption[]> = new InjectionToken<CookieConsentOption[]>(
  'cookieConsentOptions',
  {
    factory: () => [
      {
        type: 'Necessary',
        title: $localize`Necessary`,
        subTitle: $localize`Essential for the website's basic functionality.`
      },
      {
        type: 'Preferences',
        title: $localize`Preferences`,
        subTitle: $localize`Remember your choices for a better browsing experience.`
      },
      {
        type: 'Analytics',
        title: $localize`Analytics`,
        subTitle: $localize`Gather insights into website usage for performance improvement.`
      },
      {
        type: 'Marketing',
        title: $localize`Marketing`,
        subTitle: $localize`Track user activity for displaying relevant ads.`
      }
    ]
  }
);
